import { render, staticRenderFns } from "./ui-tabs.vue?vue&type=template&id=3399979f&"
import script from "./ui-tabs.vue?vue&type=script&lang=ts&"
export * from "./ui-tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports